module.exports = __webpack_public_path__ + "static/media/not-found.bafaf698.svg";